/**
 * 입력값을 접두어로 사용해 XXXX-XXXX-XXXX-XXXX 형식의 시리얼을 생성합니다.
 * 혼동하기 쉬운 I, O, 0, 1 문자는 생성 문자에서 제외됩니다.
 */
export function generateSerial(inputVariable) {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  const totalBlocks = 4;
  const blockSize = 4;
  const cryptoProvider = typeof window !== 'undefined' ? window.crypto : undefined;

  if (!cryptoProvider?.getRandomValues) {
    throw new Error('보안 난수 생성 기능을 사용할 수 없습니다.');
  }

  const blocks = Array.from({ length: totalBlocks }, () => {
    let block = '';
    const randomValues = new Uint32Array(blockSize);
    cryptoProvider.getRandomValues(randomValues);

    for (let i = 0; i < blockSize; i += 1) {
      block += chars[randomValues[i] % chars.length];
    }
    return block;
  });

  return `${inputVariable}-${blocks.join('-')}`;
}

/**
 * 하드웨어 식별자들을 결합하여 SHA-256 해시를 생성합니다.
 * @param {string} machineGuid - 윈도우 레지스트리 MachineGuid 등
 * @param {string} biosUuid - BIOS UUID
 * @param {string} motherboardSerial - 메인보드 시리얼 번호
 * @returns {Promise<string>} SHA-256 해시 문자열 (64글자 16진수)
 */
export const generateMachineHash = async (machineGuid, biosUuid, motherboardSerial) => {
  try {
    const guid = (machineGuid || '').trim();
    const bios = (biosUuid || '').trim();
    const mb = (motherboardSerial || '').trim();
    const combinedString = `${guid}${bios}${mb}`;

    if (!combinedString) {
      throw new Error('모든 식별자가 비어 있습니다.');
    }

    const cryptoProvider = typeof window !== 'undefined' ? window.crypto : undefined;
    if (!cryptoProvider?.subtle) {
      throw new Error('SHA-256 해시 기능을 사용할 수 없습니다.');
    }

    const msgBuffer = new TextEncoder().encode(combinedString);
    const hashBuffer = await cryptoProvider.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
  } catch (error) {
    console.error('해시 생성 중 오류 발생:', error);
    throw error;
  }
};
